import * as React from 'react';
import { Bem, addClass } from '../../utils';
import { Size } from '../../constants';
import './Button.css';
import { useId } from '../../utils/hooks/useId';
export var ButtonType;
(function (ButtonType) {
    ButtonType["Secondary"] = "secondary";
    ButtonType["Primary"] = "primary";
    ButtonType["Link"] = "link";
})(ButtonType || (ButtonType = {}));
const { Secondary, Primary, Link } = ButtonType;
const bem = Bem.create('vai-button');
export const Button = React.forwardRef(function Button(props, ref) {
    const { dataTa, buttonType = ButtonType.Primary, buttonSize = Size.M, children, htmlId, className, startIcon: startIconProp, type = 'button', disabled, ...rest } = props;
    const id = useId(htmlId, ['button']);
    const startIcon = startIconProp && React.createElement("span", { className: bem.element('icon-start')() }, startIconProp);
    const iconClass = startIconProp ? 'start-icon' : undefined;
    return (React.createElement("button", Object.assign({ id: id.toString(), "data-ta": dataTa, className: addClass(bem.block(buttonType, buttonSize, iconClass), className), type: type, disabled: disabled, ref: ref }, rest),
        startIcon,
        React.createElement("span", { className: bem.element('text')() }, children)));
});
Button.metaProperties = ['disabled'];
Button.Type = { Primary, Secondary, Link };
//# sourceMappingURL=Button.js.map